import { IconClose } from '@components/shared';
import React, { ReactNode } from 'react';

interface Props {
  text?: ReactNode;
  onClick?: () => void;
}

export function TagFilter(props: Props) {
  const { text = '', onClick } = props;

  return (
    <span className="font-bold bg-slate-100 pl-2 pr-1 rounded text-gray-800 typography-h5 flex justify-center items-center gap-1">
      {text}
      <IconClose className="cursor-pointer" width={16} height={16} onClick={onClick} />
    </span>
  );
}
